export enum OptionTypes {
    NONE = 0,
    CONSULTANTS,
    PROPERTIES,
    REPORTS,
    GUARANTEES,
    COMMERCIAL_REGIONS,
    KANBAN,
    MORE_OPTIONS,
    CONTRACTS,
    RENT
}